import React from "react";
import { Panel, Loader } from "@culturehq/components";
import * as CHQ from "chq";

import analytics from "images/analytics.svg";

import { useGet } from "app/hooks";
import { formatThousand, t, Trans } from "app/utils";
import { Params } from "@culturehq/client";
import getUserName from "app/utils/getUserName";

type TellerProps = {
  teller: CHQ.StoryTeller;
};

const Teller: React.FC<TellerProps> = ({ teller }) => (
  <li>
    <div className="profile_name">
      <img src={teller.user.avatar.thumbUrl} alt={getUserName(teller.user)} />
      <span>
        <h5>{getUserName(teller.user)}</h5>
        <h5 className="text_secondary">{teller.user.title}</h5>
      </span>
    </div>
    <h4>{formatThousand(teller.told)}</h4>
  </li>
);

export type ListTopStoryTellers = {
  tellers: CHQ.StoryTeller[];
};

type TopStoryTellersProps = {
  external?: boolean;
  params: Params;
};

const TopStoryTellersContent: React.FC<TopStoryTellersProps> = ({ external, params }) => {
  const get = useGet<ListTopStoryTellers>(`/analytics/stories/tellers${external ? "?external=true" : ""}`, params);

  if (get.getting) {
    return <Loader loading />;
  }

  if (get.error) {
    throw new Error(t("Looks like there has been an unexpected error. Please reload the page."));
  }

  return (
    <div className="card_info">
      <ul className="profile_list">
        {get.got.tellers.length !== 0 && get.got.tellers.map(teller => (
          <Teller key={teller.user.id} teller={teller} />
        ))}
      </ul>

      {get.got.tellers.length === 0 && (
        <div className="StoryAnalyticsTable--Empty">
          <img className="StoryAnalyticsTable--Empty__Image" src={analytics} alt={t("Empty data")} />
          <h4 className="StoryAnalyticsTable--Empty__Label"><Trans>No data to display yet</Trans></h4>
        </div>
      )}
    </div>
  );
};

const TopStoryTellers: React.FC<TopStoryTellersProps> = ({ external, params }) => (
  <Panel>
    <Panel.Body className="card_holder">
      <div className="card_title">
        <h3>
          {external
            ? <Trans>Top Viewed Storytellers</Trans>
            : <Trans>Top Storytellers</Trans>}
        </h3>
      </div>
      <TopStoryTellersContent external={external} params={params} />
    </Panel.Body>
  </Panel>
);

export default TopStoryTellers;
